import { provide, InjectionKey, inject, watch, type ShallowRef } from 'vue'

const mapInstanceKey: InjectionKey<ShallowRef<AMap.Map | null>> = Symbol()

/**
 * 在地图组件中提供地图实例的 Ref
 * 传入的 instance 可以是 Ref 或者普通值
 */
export const useProvideMapContext = (instance: ShallowRef<AMap.Map | null>) => {
  // 如果传入的是普通值，包装成 ref
  provide(mapInstanceKey, instance)
}

/**
 * 在子组件中获取地图实例
 * 返回一个 Ref，可以响应式地监听地图实例的变化
 */
export const useMapContext = () => {
  return inject(mapInstanceKey)
}

export const useMapReady = () => {
  const map = useMapContext()
  return new Promise<AMap.Map>((resolve) => {
    if (map?.value) {
      resolve(map.value)
    } else {
      const stop = watch(
        () => map?.value,
        (value) => {
          if (value) {
            resolve(value)
            stop() // 停止监听
          }
        },
        { immediate: true, deep: true },
      )
    }
  })
}
